import { render, staticRenderFns } from "./OrganizationalServices.vue?vue&type=template&id=1316169b&scoped=true"
import script from "./OrganizationalServices.vue?vue&type=script&lang=js"
export * from "./OrganizationalServices.vue?vue&type=script&lang=js"
import style0 from "./OrganizationalServices.vue?vue&type=style&index=0&id=1316169b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1316169b",
  null
  
)

export default component.exports